//if (document.cookie.indexOf("test_view")>-1){ 
  	MaxVariant(44233368591, 6);
  	MaxVariant(44233813903, 6);

  	MaxVariant(31897446514750, 6);
  	MaxVariant(31897446514750, 6);

	MaxVariant(31909500289086, 6);
	MaxVariant(31909500321854, 6);

	MaxVariant(31247889203262, 1);
//}


function MaxVariant(variant_id, max){
  window.setTimeout(function(){
    if (!$("input#updates_"+variant_id).length){ return; }

    if ($("input#updates_"+variant_id).val() > max){
      console.log("MaxVariant "+variant_id+" over max "+max);
      UpdateCart("updates["+variant_id+"]="+max);
    }

    window.setTimeout(function(){
      $("input#updates_"+variant_id).closest(".cart__row").addClass("v_"+variant_id+" max_qty max_"+max);
      window.setTimeout(function(){
        $("input#updates_"+variant_id).closest(".cart__row").addClass("v_"+variant_id+" max_qty max_"+max);
      },1000);    
    },1000);      

  },100);
}

ClosePopup();

function ClosePopup(){
  window.setTimeout(function(){
    if ($("#cboxClose").length){
      $("body").attr("closed-popup","true");
      $("#cboxClose").click();
      console.log("closed popup");
    } else{
     	ClosePopup(); 	 
    }
    
    
    
  },1000);
}